import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { SwivuGrid } from "./SwivuGrid.jsx";

export class SwivuModernGrid extends SwivuGrid {
  static get $name() {
    return "SwivuModernGrid";
  }

  static get type() {
    return WIDGET_KEYS.swivuModernGrid;
  }

  static get configurable() {
    return {
      ...super.configurable,
      cls: "swivu-modern-grid",
      listeners: {
        cellContextMenu: "configureGridActionsShow",
        headerMenuShow: "onMenuShow"
      }
    }
  }

  construct(config) {
    this.configureGridActions(config);
    this.configureGridTopbar(config);
    super.construct(...arguments);
  }

  configureGridActions(config) {
    if (config.features.cellMenu && !config.features.cellMenu.disabled) {
      config.features.cellMenu.disabled = true; // Prevent context menu open from rows
      config.columns.push({
        id: "swivu-modern-grid-context-menu",
        type: 'action',
        enableHeaderContextMenu: false,
        hideable: false,
        align: "center",
        actions: [{
          cls: 'fa-solid fa-ellipsis text-black dark:text-white hover:bg-[var(--grid-border-color)] !rounded-md h-6 w-6 p-0',
          onClick : ({ grid, record, target, column }) => {
            this.features.cellMenu.disabled = false; // Enable context menu open
            grid.features.cellMenu.showMenuFor({ record, column }, { targetElement: target }); // This function will now be able to open the context menu, because we enabled it above.
            this.features.cellMenu.disabled = true; // Disable context menu open
          }
        }]
      })
    }
  }

  configureGridTopbar(config) {
    if (config.swivuGridTitle) {
      if (!config.tbar) config.tbar = { items: {} };
      config.tbar.items["swivuGridTitle"] = {
        type: "displayField",
        value: config.swivuGridTitle,
        cls: "swivu-grid-title flex-1 text-swivu-md font-semibold text-[#282828] dark:text-[#f0f0f0] [&_span]:!p-0",
        weight: 100
      }
    }

    if (config.tbar) {
      if (!config.tbar.cls) config.tbar.cls = "";
      config.tbar.cls += " swivu-modern-grid-tbar [&_.b-toolbar-content]:items-center [&_.b-toolbar-content]:p-0 [&_.b-toolbar-content]:!min-h-[auto]";
    }
  }

  configureGridActionsShow({ grid }) {
    this.onMenuShow({ menu: grid.features.cellMenu.menu });
  }

  onMenuShow({ menu }) {
    if (menu) {
      menu.element.classList.add("swivu-modern-context-menu");
    }
  }

  onRowLinesChange(value) {
    this.element.classList.toggle("swivu-modern-grid-borders", value);
  }
}

SwivuModernGrid.initClass();
